// extracted by mini-css-extract-plugin
module.exports = {"gallery":"PrintGallery-module--gallery--1eO_f","image":"PrintGallery-module--image--3bBD_"};